import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/bull_text_circle.svg")